import styled from 'styled-components';

import { Body } from '@cognite/cogs.js';

export const StyledErrorMessage = styled(Body)`
  font-family: 'Source Code Pro', sans-serif;
  overflow-wrap: break-word;
  white-space: pre-wrap;
`;
